export default {
  app_name: 'MiPeso',
  dialog_btn_ok: 'OK',
  dialog_btn_got_it: 'Got it',
  btn_submit: 'Submit',
  btn_continue: 'Continue',
  common_placeholder_input: "Please fill in",
  common_loading: "Loading...",

  title_detail: "Loan Details",
  title_extend: "Extend Loan Term",
  title_extend_list: "Loan Extension Records",
  title_about: "About App",
};
